// extracted by mini-css-extract-plugin
export default {"label_spec":"ChipGroup_label_spec__kf+Ds","chips":"ChipGroup_chips__Nrd6c","chip":"ChipGroup_chip__ksnXT"};